import { useRef, useEffect, useState } from "react";
import { getAreapCook } from "../../../../utils/params";
import Cookies from "universal-cookie";
import { socketon } from "../../../../utils/socket";
import { beep } from "../../../../utils/beeps";
import Toasts from "../../../toast";
import PropTypes from 'prop-types';

function Left({celdas,celdaheight, voce}) 
 {
   const [Modulos, setModulos] = useState([]);
   const [opciones, setOpciones] = useState([]);
   const [showToast, setShowToast] = useState(false);
   const [turnos, setTurnos] = useState([]);
   const [selectedVoice, setSelectedVoice] = useState(voce);
   const [pitch, setPitch] = useState(1.2);
   const [volume, setVolume] = useState(1);
   const [rate, setRate] = useState(0.8);
    
   const colaTurnos = useRef([]);
   const procesando = useRef(false);
   
   let cookies = new Cookies();
   
  const procesarCola = async () => 
     {
       if (procesando.current || colaTurnos.current.length === 0) return;

       procesando.current = true;
       const siguiente = colaTurnos.current.shift(); // {modulo, turno}

       setTurnos((prev) => 
        {
          // Elimina si ya estaba (comparando por turno y módulo)
          const sinDuplicados = prev.filter(
             (t) => !t || t.turno !== siguiente.turno || t.modulo !== siguiente.modulo
           );
          // Añade el nuevo al inicio
          return [siguiente, ...sinDuplicados].slice(0, 10);
        });

       await new Promise((res) => setTimeout(res, 3000));
       procesando.current = false;
       procesarCola();
     };
  //----------------
  const agregarTurno = (nuevo) => 
    {
     const yaEnCola = colaTurnos.current.some(
        (t) => t.turno === nuevo.turno && t.modulo === nuevo.modulo
      );
     
     if (!yaEnCola) 
      {
       colaTurnos.current.push(nuevo);
       procesarCola();
      }
    };
  //-----------
  const CardModulos = ({ data, heights }) => 
  (
      
           <div className={`flex flex-row w-full`} style={{ height: `${heights}rem` }}>
               <div className="flex w-1/2 h-full border-x-[0.09rem] border-b-[0.09rem] border-white text-center items-center justify-center">
                  <span className="text-4xl font-poppins font-medium text-yellow-300 text-center">{data?.modulo||''}</span>
               </div>
               <div className="flex w-1/2 h-full border-r-[0.09rem] border-b-[0.09rem] border-white text-center items-center justify-center">
                  <span className="text-4xl font-poppins font-medium text-yellow-300 text-center">{data?.turno || ''}</span>
               </div>
           </div>
  );
  
  //------------
  const ActualizarModulo = () => 
    {
       let AreaId = getAreapCook();
       socketon.on("ActualizaTurno", (message, sender) => 
        {
          console.log(message)
           if (message) 
            {
               if (message[0].AreaId.toString() === AreaId)
                 {
                  
                   agregarTurno({turno:message[0].Prefijo+message[0].Consecutivo,
                                 modulo:message[0].CodigoMod 
                   });
                   beep();
                   InicioBienvenida(message[0].Prefijo, message[0].Consecutivo,message[0].CodigoMod)
                 }  
            }
        });
    };
//---------------
  const InicioBienvenida = (Prefijo, Consecutivo, Modulo) =>
    {
     const Turno = SepararTextos(Prefijo ??'');
     const Module = SepararTextos(Modulo ??'');
     playVoice2("Turno  " + Turno+ Consecutivo +"Módulo "+ Module );
    }
/***
 * 
 */
const playVoice = text => {
  console.log("Aca");
  const synth = window.speechSynthesis;
     // enter your voice here, because voices list loads asynchronously.. check the console.log below.
     setSelectedVoice(cookies.get('Ctrvoice'));

     const vocey=cookies.get('Ctrvoice')
     console.log('voz cookie:', vocey);
     //alert(cookies.get('Ctrvoice'))
     if (vocey)
     {
      // getVoice(vocey.name, synth)
      // .then(voice => {
           const utterThis = new SpeechSynthesisUtterance(text);
           utterThis.voice = vocey.name;
           utterThis.pitch = pitch;
           utterThis.volume = volume;
           utterThis.rate = rate;
           synth.speak(utterThis);
      // })
      // .catch(error => alert("error: " + error));
      }
};
//------------------------------------------------------
function getVoice(voiceName, synth) {
  return new Promise((resolve, reject) => {
    const loadVoices = () => {
      const voices = synth.getVoices();
      const selectedVoice = voices.find(voice => voice.name === voiceName);

      if (selectedVoice) {
        resolve(selectedVoice);
      } else {
        reject("No se encontró la voz: " + voiceName);
      }
    };

    // Las voces pueden no estar disponibles inmediatamente
    if (synth.getVoices().length !== 0) {
      loadVoices();
    } else {
      synth.onvoiceschanged = loadVoices;
    }
  });
}

const playVoice2 = (text) => {
  console.log("playVoice ejecutado");

  const synth = window.speechSynthesis;
  const voiceName = cookies.get('Ctrvoice');

  if (!voiceName) {
    console.error("No hay voz en cookie");
    return;
  }

  const speak = () => {
    const voices = synth.getVoices();
    const voice = voices.find(v => v.name === voiceName);

    if (!voice) {
      console.error("Voz no encontrada:", voiceName);
      return;
    }

    const utter = new SpeechSynthesisUtterance(text);
    utter.voice = voice;
    utter.pitch = pitch;
    utter.rate = rate;
    utter.volume = volume;

    synth.cancel(); // evita superposición
    synth.speak(utter);
  };

  // Si aún no cargan las voces
  if (synth.getVoices().length === 0) {
    synth.onvoiceschanged = speak;
  } else {
    speak();
  }
};

/**
 * 
 */
const SepararTextos = (Dato) => {
  if (!Dato || typeof Dato !== 'string') return '';
  return Dato.split('').join(' ') + ' ';
}//----------------------------------------
  useEffect(() => {
    beep();
    //getFillModulos();
    
    setPitch(cookies.get('Ctrpitch')||1.2);
    setVolume(cookies.get('Ctrvolume'|| 1));
    setRate(cookies.get('Ctrrate'||0.8));
    setSelectedVoice(cookies.get('Ctrvoice'));
    ActualizarModulo();
    return () => {
      return () => {
        socketon.on("disconnect", () => {    });
        };
    };
    playVoice2('Bienvenidos a Waitless');
  }, []);

  useEffect(() => {
  setTurnos(Array(Number(celdas)).fill(null));
}, [celdas]);

  return (
    <>
    <div className="flex w-full flex-col m-2">
      <div className="flex flex-row w-full h-[4rem]">
        <div className="flex w-1/2 h-full border-[0.09rem] border-white text-center items-center justify-center">
          <span className="text-4xl font-poppins font-medium text-yellow-300 text-center">Modulo</span>
        </div>
        <div className="flex w-1/2 h-full border-[0.09rem] border-white text-center items-center justify-center">
          <span className="text-4xl font-poppins font-medium text-yellow-300 text-center">Turno</span>
        </div>
      </div>
      {Array.from({ length: celdas }).map((_, i) => (
        <div key={i}>
           <CardModulos data={turnos[i]} heights={celdaheight} />
        </div>
      ))}
    </div>
  {showToast ? (
    <Toasts
      type={opciones.type}
      message={opciones.message}
      active={opciones.active}
    ></Toasts>
  ) : (
    ""
  )}
  </>
  );
  
}
Left.propTypes = {
      celdas: PropTypes.number.isRequired,
      celdaheight: PropTypes.number.isRequired,
      voce: PropTypes.object.isRequired
    };

export default Left;
